import {HeaderLinkProps} from '@web-catalog/types';

import {emitYmEvent, logTmrEvent} from '@web-catalog/utils/analytics';

export const logHeaderLinkClick = (props: HeaderLinkProps) => {
  switch (props.title) {
    case 'Разработчикам':
      emitYmEvent({eventName: 'header_menu_button_developers'});
      logTmrEvent({logEvent: 'devTop.click'});

      break;

    case 'Игры':
      emitYmEvent({eventName: 'header_menu_button_games'});
      logTmrEvent({logEvent: 'gamesTop.click'});

      break;

    case 'Помощь':
      emitYmEvent({eventName: 'header_menu_button_help'});

      logTmrEvent({logEvent: 'supportTop.click'});

      break;

    case 'Приложения':
      emitYmEvent({eventName: 'header_menu_button_apps'});

      logTmrEvent({logEvent: 'appsTop.click'});

      break;
  }

  logTmrEvent({
    logEvent: 'header.click',
    params: {button_text: props.title},
  });
};
